import QueryBuilder from "./queryBuilder.js";

export default function knex(configs) {
    if (configs.client !== 'sqlite3') {
        throw new Error('The knex mock only support sqlite logic');
    }
    return new QueryBuilder();
}